import { makeStyles } from "@mui/styles";
const drawerWidth = 240;

export const commonStyles = makeStyles((theme) => ({
    label: {
        color: "#8798AD",
        fontSize: "13px",
        fontWeight: "300",
    },
}));